export const TRANSACTIONS_LIST_REQUEST = "TRANSACTIONS_LIST_REQUEST";
export const TRANSACTIONS_LIST_RESPONSE =
  "TRANSACTIONS_LIST_RESPONSE";
